import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import { MarkerFilterDropdownComponent } from './marker-filter-dropdown.component';
import { MarkerModule } from '@go-modules/components/marker/marker.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		GoSelectModule,
		MatTooltipModule,
		MarkerModule
	],
	declarations: [
		MarkerFilterDropdownComponent
	],
	exports: [
		MarkerFilterDropdownComponent
	]
})
export class MarkerFilterDropdownModule {}
